import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_PLANT" }
);

export interface CreatePlantState extends IState {}

const INITIAL_STATE: CreatePlantState = {
  loading: false,
  error: null,
};

const request = (state: CreatePlantState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreatePlantState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CreatePlantState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createPlant = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreatePlantTypes = Types;
export const CreatePlantActions = Creators;
